import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import AppLayout from './components/layout/AppLayout';
import AppRouting from './components/routing/AppRouting';
import IntlProvider from './services/providers/Intl';
import { ApiProvider } from 'services/providers/api/Api';
import { ConfigProvider } from 'antd';

import 'styles/app';
import UserProvider from './services/providers/UserProvider';

const App = () => {
  const customTheme = {
    token: {
      colorPrimary: '#170f4f',
      colorTextBase: '#170f4f',
      fontFamily: 'Roboto',
      colorLink: '#170f4f',
      colorTextDisabled: 'rgba(23, 15, 79, 0.7)',
    },
    components: {
      Select: {
        multipleItemColorDisabled: 'rgba(23, 15, 79, 0.7)',
      },
    },
  };

  return (
    <ConfigProvider theme={customTheme}>
      <Router>
        <IntlProvider>
          <ApiProvider>
            <UserProvider>
              <AppLayout>
                <AppRouting />
              </AppLayout>
            </UserProvider>
          </ApiProvider>
        </IntlProvider>
      </Router>
    </ConfigProvider>
  );
};

export default App;
